export const environment = {
  production: false,
  api: 'https://beta-api.roadsentinel.app',
  tcpHost: '3.137.55.106',
  websocketHost: 'wss://beta-api.roadsentinel.app',
  topic: '/topic/alarms'
}
